import { createSlice } from '@reduxjs/toolkit';

// Redux Slice (produitSlice.js)
const annonceSlice = createSlice({
    name: 'annonce',
    initialState: {
      annonceId: '-1',  // Initial value as -1 (no product selected)
    },
    reducers: {
      setAnnonceId: (state, action) => {
        state.annonceId = action.payload;  // Update produitId with the selected product ID
      },
      resetAnnonceId: (state) => {
        state.annonceId = '-1';  // Reset to -1 when needed (e.g., when navigating away from the product details)
      },
    },
  });
  
  export const { setAnnonceId, resetAnnonceId } = annonceSlice.actions;
  export default annonceSlice.reducer;
  
